
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAcdcConverter as ObiAcdcConverterElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-acdc-converter.js';
 
 
 

 
 export const ObiAcdcConverter = createComponent({
   react: React,
   tagName: 'obi-acdc-converter',
   elementClass: ObiAcdcConverterElement,
   events: {
     
   }
  });
 
 